export const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    maxWidth: 500,
    minWidth: 300,
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
    padding: '25px 25px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '70%',
};